//--------------------------------------------------------------------------
// <copyright file="App.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import Userapp from "./Userapp";

const App = () => {
 return <Userapp />;
}

export default App;
